/**
 * GoToMap use case (contracts.md): switch to map scene, update render with map view.
 */

import type { RenderPort } from "../ports.js";
import { mapStateToView } from "../state-view.js";
import type { AppState } from "../types.js";
import type { MageProfile } from "../../domain/mage-profile.js";

export interface GoToMapDeps {
  render: RenderPort;
  /** Current app state for map (mapProgress, etc.). If not provided, view uses null for mapProgress. */
  getState?: () => Pick<AppState, "mapProgress" | "selectedFieldId">;
  /** Optional getter for mage profile (for XP bar display). */
  getMageProfile?: () => MageProfile;
}

export function createGoToMap(deps: GoToMapDeps): () => void {
  return function goToMap(): void {
    const state: AppState = {
      scene: "map",
      mapProgress: deps.getState?.()?.mapProgress,
      selectedFieldId: deps.getState?.()?.selectedFieldId ?? null,
    };
    const mageProfile = deps.getMageProfile?.();
    deps.render.setScene("map");
    deps.render.update(mapStateToView(state, mageProfile));
  };
}
